import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import AuthService from '../../services/AuthService';
import UserSessionManager from '../../utils/UserSessionManager';
import FeatureFlagService from '../../services/FeatureFlagService';
import { getSubdomainFromUrl } from '../../utils/tenant';        // ← new import
import { setSubdomain } from '../../utils/authStorage';          // ← new import

const SignIn = () => {
  const navigate = useNavigate();

  // Read subdomain from URL automatically
  const urlSubdomain = getSubdomainFromUrl();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSignIn = async (e) => {
    e.preventDefault();
    setErrors({});

    const subdomain = urlSubdomain || null;    

    const loginData = {
      email,
      password,
      subdomain,   // ← send subdomain instead of accountId
    };

    try {
      const response = await AuthService.login(loginData);
      if (response?.accessToken) {
        UserSessionManager.setSession({
          ...response,
          email: response.email ?? response.Email ?? email,
        });
        setSubdomain(subdomain);
        FeatureFlagService.fetchAndCache();
        if (UserSessionManager.requiresPasswordChange()) {
          navigate("/changepassword", { state: { forced: true, email } });
        } else {
          navigate("/dashboard");
        }
      } else {
        setErrorMessage("Login failed. Please try again.");
      }
    } catch (err) {
      if (err.message === "User not found.") {
        setErrorMessage("Invalid Email Or Password!");
      } else {
        setErrorMessage(err.message || "Something went wrong");
        if (err.errors && Array.isArray(err.errors)) {
          let formattedErrors = {};
          err.errors.forEach(errObj => {
            formattedErrors = { ...formattedErrors, ...errObj };
          });
          setErrors(formattedErrors);
        }
      }
    }
  };

  return (
    <div className="bg-light py-5">
      <Container className="bg-white rounded shadow p-4">
        <Row className="align-items-center">
          <Col md={6} className="text-center">
            <img
              src='/assets/images/login-illustration.png'
              alt="Login Illustration"
              className="img-fluid rounded mb-3"
              style={{ maxHeight: '300px' }}
            />
            <p className="text-muted fs-5">Let us help you grow..</p>
          </Col>

          <Col md={6}>
            <div className="p-3">
              <h2 className="fw-bold mb-2 d-flex align-items-center gap-2">
                Sign In
                <img src='/assets/images/logo.png' alt="Logo" width="50" />
              </h2>

              <Form onSubmit={handleSignIn}>
                {errorMessage && (
                  <div className="text-danger mb-3 text-center fw-semibold">
                    {errorMessage}
                  </div>
                )}

                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                    isInvalid={!!errors.Email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.Email}
                  </Form.Control.Feedback>
                  <a href="/forgotemail" className="text-primary small">Forgot email</a>
                </Form.Group>

                <Form.Group className="mb-3 position-relative" controlId="formPassword">
                  <Form.Label>Password</Form.Label>
                  <div className="d-flex align-items-center position-relative">
                    <Form.Control
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Enter password"
                      required
                      onChange={(e) => setPassword(e.target.value)}
                      isInvalid={!!errors.Password}
                    />
                    <Button
                      variant="link"
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        padding: 0,
                        fontSize: '1.25rem',
                        color: '#555',
                        textDecoration: 'none'
                      }}
                    >
                      <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                    </Button>
                    <Form.Control.Feedback type="invalid">
                      {errors.Password}
                    </Form.Control.Feedback>
                  </div>
                  <a href="/forgotpassword" className="text-primary small">Forgot password</a>
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100 text-white fw-semibold"
                  style={{ backgroundColor: '#CC5500', border: 'none' }}
                >
                  Sign In
                </Button>
              </Form>

              <p className="mt-3 text-center">
                Don't have an account? <a href="/signup" className="text-primary">Sign up</a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SignIn;